import { t } from 'i18next'
import { RouteObject } from "react-router-dom";
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react';

const QualityCertificationPage  = lazy( () => import('../containers/QualityCertification/QualityCertificationContainer') );
const QualityCertificationDocumentPage = lazy( () => import('../containers/QualityCertification/QualityCertificationDocumentContainer') );

export const QUALITY_CERTIFICATION_PATHS = {
    HOME: '/quality-certification',
    QUALITY_CERTIFICATE_PDF: (certificateNumber?: number) => `/quality-certification/get-document/${certificateNumber ? certificateNumber : ':certificateNumber'}`
} as const

export const qualityCertificationRoutes: RouteObject[] = [
    {
        path: QUALITY_CERTIFICATION_PATHS.HOME,
        children: [
            {
                index: true,
                element: <QualityCertificationPage />,
                handle: {
                  crumb: (): MenuItem[] => [
                    { label: t('general:menu.quality_certification') || '', url: QUALITY_CERTIFICATION_PATHS.HOME },
                  ],
                },
            },
            
            {
              path: QUALITY_CERTIFICATION_PATHS.QUALITY_CERTIFICATE_PDF(),
              element: <QualityCertificationDocumentPage />,
            }
            
        ],
    }
]